import React, { Component } from "react";
import Functions from "../../src/functions";
import Controls from "../controls";
import {
  arrayMove,
  sortableContainer,
  sortableElement,
} from "react-sortable-hoc";

const SortableItem = sortableElement(({ value }) => <li>{value}</li>);

const SortableContainer = sortableContainer(({ children }) => {
  return (
    <ul className="pl-0" style={{ listStyle: "none" }}>
      {children}
    </ul>
  );
});

class Multiple extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: [],
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
    controls: [],
  };

  constructor(props) {
    super(props);

    this.removeComponent = this.removeComponent.bind(this);
    this.addComponent = this.addComponent.bind(this);
    this.onReorder = this.onReorder.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = [];
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    let controlProperties = {};
    let canAdd = true;
    let canRemove = true;
    let addLabel = "Add new";

    if (this.props.property.configuration) {
      controlProperties = this.props.property.configuration.properties;
      canAdd =
        this.props.property.configuration.canAdd === false ? false : canAdd;
      canRemove =
        this.props.property.configuration.canRemove === false
          ? false
          : canRemove;

      addLabel = this.props.property.configuration.addLabel
        ? this.props.property.configuration.addLabel
        : addLabel;
    }

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
      controlProperties: controlProperties,
      canAdd: canAdd,
      canRemove: canRemove,
      addLabel: addLabel,
    };
  }

  componentDidMount() {
    if (this.didMount) {
      this.didMount();
    }
  }

  removeComponent(index) {
    let defaultValue = [...this.state.defaultValue];
    defaultValue.splice(index, 1);
    this.setState({ defaultValue: defaultValue });
  }

  addComponent() {
    let defaultValue = this.state.defaultValue;
    defaultValue.push({});

    this.setState({ defaultValue: defaultValue });
  }

  onReorder(arg) {
    this.setState({
      defaultValue: arrayMove(
        this.state.defaultValue,
        arg.oldIndex,
        arg.newIndex
      ),
    });
  }

  render() {
    let output = [];
    this.state.defaultValue.map((record, idx) => {
      let multipleSection = [];

      Object.keys(this.state.controlProperties).map((itm, ctrlidx) => {
        let property = { ...this.state.controlProperties[itm] };

        let Control = Controls[property["type"]];

        let dataRecord = { ...record };

        let value = record[property["alias"]] ? record[property["alias"]] : "";
        let refPrimaryKey = property["alias"] + "-" + idx + "-ref";

        property["alias"] =
          this.props.property["alias"] +
          "[" +
          idx +
          "][" +
          property["alias"] +
          "]";

        this.props.manager[refPrimaryKey] = React.createRef();
        this.props.manager["validation-" + property["alias"] + "-ref"] =
          React.createRef();

        let ValidationComponent = null;

        if (property["validations"]) {
          let ValidationControl = Controls["validationcontrol"];

          ValidationComponent = (
            <ValidationControl
              {...property}
              key={Functions.key()}
              ref={
                this.props.manager["validation-" + property["alias"] + "-ref"]
              }
            ></ValidationControl>
          );
        }

        let ControlUI = Functions.getTemplate("control");

        let ControlComponent = {
          value: value,
          showPropertyOnTemplate: true,
          component: (
            <Control
              value={value}
              data={dataRecord}
              key={Functions.key()}
              property={property}
              // primaryKey={record[primaryKey]}
              ref={this.props.manager[refPrimaryKey]}
              manager={this.props.manager}
              validationComponent={
                ValidationComponent ? ValidationComponent : null
              }
            ></Control>
          ),
          validationComponent: ValidationComponent ? ValidationComponent : null,
          data: dataRecord,
          property: property,
        };

        multipleSection.push(
          <React.Fragment>
            <ControlUI control={ControlComponent}></ControlUI>
            {ControlComponent.validationComponent}
          </React.Fragment>
        );
      });

      let key = Functions.key();
      output.push(
        <div className="card" key={key}>
          <div className="card-header pt-1 pb-1 bg-light">
            <div className="row">
              <div className="col">
                {this.props.property.configuration.title
                  ? this.props.property.configuration.title(record)
                  : "Item " + (idx + 1)}
              </div>
              <div className="col  text-right">
                <i className="fas fa-arrows-alt pointer mr-2"></i>
                {this.state.canRemove ? (
                  <i
                    className="far fa-times-circle  pointer  mr-2"
                    title="Remove"
                    onClick={(e) => this.removeComponent(idx)}
                  ></i>
                ) : (
                  ""
                )}
                <i
                  className="fas pointer"
                  data-toggle="collapse"
                  data-target={"#" + key}
                ></i>
              </div>
            </div>
          </div>
          <div className="card-body collapse" id={key}>
            {multipleSection}
          </div>
        </div>
      );
    });

    return (
      <React.Fragment>
        <SortableContainer onSortEnd={this.onReorder} pressDelay={200}>
          {output.map((value, index) => (
            <SortableItem key={`item-${index}`} index={index} value={value} />
          ))}
        </SortableContainer>
        {this.state.canAdd ? (
          <button
            type="button"
            className="btn btn-link border"
            onClick={this.addComponent}
          >
            {this.state.addLabel}
          </button>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

export default Multiple;
